import styled from "@emotion/styled";

import { fontMerriweather, fontRobotoCondensed } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.div`
  color: #333333;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  letter-spacing: 0;
  text-align: start;
  text-transform: uppercase;
`;

export const SubTitle = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 20px;
  font-family: ${fontMerriweather};
  line-height: 1.4;
  text-align: start;
`;
